module.exports = __webpack_public_path__ + "img/E254.55b551da.svg";